export default "__VITE_ASSET__7vtXqKEl__"